import { Box } from "@design-system/Box/Box";
import { Clickable } from "@design-system/Clickable/Clickable";
import { Icon } from "@design-system/Icon/Icon";
import { Table } from "@design-system/Table/Table";

import classes from "./ExpandableResourceCell.module.css";

type Props = {
  name: string;
  subtext?: string;
  signedLogoUrl?: string;
  domain: string;
  additionalResourcesCount: number;
  isExpanded: boolean;
  onToggleExpansion: () => void;
  isNestedResource: boolean;
};

export const ExpandableResourceCell = ({
  name,
  subtext,
  signedLogoUrl,
  domain,
  additionalResourcesCount,
  isExpanded,
  onToggleExpansion,
  isNestedResource,
}: Props) => {
  const handleChevronClick = () => {
    onToggleExpansion();
  };

  return (
    <Box direction="row" align="center" justify="space-between" grow={1}>
      {isNestedResource ? (
        <Box direction="row" align="center" gap={8}>
          <Table.CompanyCell
            name={name}
            subtext={subtext}
            signedLogoUrl={signedLogoUrl}
            domain={domain}
          />
        </Box>
      ) : (
        <Table.CompanyCell
          name={name}
          subtext={subtext}
          signedLogoUrl={signedLogoUrl}
          domain={domain}
        />
      )}
      {!isNestedResource && additionalResourcesCount > 0 && (
        <div style={{ marginLeft: "8px" }}>
          <Clickable onClick={handleChevronClick} outline="none">
            <div className={classes.chevronButton}>
              <Icon
                icon="faChevronRight"
                size="sm"
                className={isExpanded ? classes.rotated : undefined}
              />
            </div>
          </Clickable>
        </div>
      )}
    </Box>
  );
};
